module.exports = __webpack_public_path__ + "img/bf.0a46a44d.png";